import { ExternalLink } from "lucide-react";
import { COUNTRY_NL, VIGNETTES, TOLL_COUNTRIES } from "../lib/countries";

export const VignetteAdvice = ({ countries }) => {
  if (!countries?.length) return null;
  const ccs = countries.filter((cc) => VIGNETTES[cc]);
  const tolls = countries.filter((cc) => TOLL_COUNTRIES.includes(cc));
  return (
    <div data-testid="vignette-advice" className="space-y-2 border-b border-border/40 pb-3">
      <p className="text-[11px] tracking-[0.15em] uppercase font-semibold text-muted-foreground">Vignetten & tol op je route</p>
      {ccs.length === 0 && <p data-testid="vignette-none" className="text-xs text-emerald-700 font-semibold">Geen vignet nodig op deze route.</p>}
      {ccs.map((cc) => {
        const v = VIGNETTES[cc];
        return (
          <div key={cc} data-testid={`vignette-row-${cc}`} className="flex items-baseline justify-between gap-3 text-sm">
            <span className="text-muted-foreground shrink-0">{COUNTRY_NL[cc] || cc}</span>
            <span className="text-right">
              <span className="font-semibold">{v.name} · {v.price}</span>{" "}
              <a href={v.url} target="_blank" rel="noreferrer" data-testid={`vignette-link-${cc}`}
                className="text-[#3A6EA5] font-semibold hover:underline whitespace-nowrap inline-flex items-center gap-0.5">
                Koop online <ExternalLink className="w-3 h-3" />
              </a>
            </span>
          </div>
        );
      })}
      {tolls.length > 0 && (
        <p data-testid="toll-note" className="text-[11px] text-muted-foreground">
          {tolls.map((cc) => COUNTRY_NL[cc] || cc).join(", ")}: tol per km — geen vignet, betaal bij de tolpoorten onderweg.
        </p>
      )}
    </div>
  );
};

export const VignetteDayNote = ({ dayEntries, dayNumber }) => {
  const ccs = (dayEntries?.[String(dayNumber)] || []).filter((cc) => VIGNETTES[cc]);
  if (!ccs.length) return null;
  return (
    <>
      {ccs.map((cc) => {
        const v = VIGNETTES[cc];
        return (
          <p key={cc} data-testid={`vignette-day-note-${dayNumber}-${cc}`}
            className="text-xs text-amber-700 bg-amber-50 rounded-lg px-3 py-1.5 inline-flex flex-wrap items-center gap-1.5 mb-3 mr-2">
            Vandaag rijd je {COUNTRY_NL[cc] || cc} binnen — vignet nodig ({v.price})
            <a href={v.url} target="_blank" rel="noreferrer" data-testid={`vignette-day-link-${dayNumber}-${cc}`}
              className="font-bold underline underline-offset-2">Koop online</a>
          </p>
        );
      })}
    </>
  );
};
